import { gql, useQuery } from '@apollo/client';
import { getTranslatedString } from 'helpers/utils-typescript';
import React, { useMemo } from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { LearningPath } from 'services/graphqltypes';

const LEARNING_PATHS = gql`
query learningPaths {
  learningPaths(orderBy: SLUG_ASC) {
    nodes {
      id
      name
    }
  }
}
`;

/** A dropdown that is used to choose Learning Path to filter by. onClick it executes callback function with the LP name as argument. */
const LearningPathDropdownFilter = ({
  filterByLearningPath,
  handleChangeFilterByLearningPath,
  className,
}: {
  filterByLearningPath: string;
  handleChangeFilterByLearningPath: (learningPath: LearningPath) => void;
  className?: string;
}): React.ReactElement => {
  const intl = useIntl();
  const currentLang = useSelector((langState: any) => langState.settings.locale);

  /* */
  /* Query */
  /* */
  const { data, loading } = useQuery(LEARNING_PATHS);
  const learningPaths: LearningPath[] = useMemo(() => {
    if (loading || !data) {
      return [];
    }
    return data.learningPaths.nodes;
  }, [data, loading]);

  /* get learningPath */
  const learningPath = useMemo(() => {
    return learningPaths.find((lp: LearningPath) => lp.id === filterByLearningPath) || null;
  }, [filterByLearningPath, learningPaths]);

  const titleElement =
    <span className="dropdown-button-text-truncate">
      {learningPath === null
        ? intl.formatMessage({ id: 'community.all-focus' })
        : getTranslatedString(learningPath?.name, currentLang)}
    </span>;

  return (
    <DropdownButton
      variant="outline-dark"
      id="filter-learning-path-button"
      className={`filter-button mr-2 ${className}`}
      title={titleElement}
      size="xs"
    >
      { /* "All focus" option*/}
      <Dropdown.Item onClick={() => handleChangeFilterByLearningPath(null)} className={filterByLearningPath === 'all' && 'selected'}>
        {intl.formatMessage({ id: 'community.all-focus' })}
      </Dropdown.Item>

      {
        learningPaths.map((learningPath, index) => {
          return (
            <div key={index}>
              <Dropdown.Item onClick={() => handleChangeFilterByLearningPath(learningPath)} className={filterByLearningPath === learningPath.id && 'selected'}>
                {getTranslatedString(learningPath?.name, currentLang)}
              </Dropdown.Item>
            </div>
          );
        })
      }
    </DropdownButton>
  );
};

export default LearningPathDropdownFilter;
